import type { OtpChannel } from '@/modules/auth/use-cases'

export type OtpFlow = 'native' | 'link'

export interface OtpFlowMemory {
  remember(channel: OtpChannel, identifier: string, flow: OtpFlow): void
  recall(channel: OtpChannel, identifier: string): OtpFlow
  forget(channel: OtpChannel, identifier: string): void
}

const OTP_FLOW_STORAGE_PREFIX = 'cc-otp-flow'

function buildKey(channel: OtpChannel, identifier: string): string {
  return `${OTP_FLOW_STORAGE_PREFIX}:${channel}:${identifier.toLowerCase().trim()}`
}

export class SessionStorageOtpFlowMemory implements OtpFlowMemory {
  remember(channel: OtpChannel, identifier: string, flow: OtpFlow): void {
    if (typeof window === 'undefined') return
    try {
      window.sessionStorage.setItem(buildKey(channel, identifier), flow)
    } catch {
      return
    }
  }

  recall(channel: OtpChannel, identifier: string): OtpFlow {
    if (typeof window === 'undefined') return 'native'
    try {
      return window.sessionStorage.getItem(buildKey(channel, identifier)) === 'link'
        ? 'link'
        : 'native'
    } catch {
      return 'native'
    }
  }

  forget(channel: OtpChannel, identifier: string): void {
    if (typeof window === 'undefined') return
    try {
      window.sessionStorage.removeItem(buildKey(channel, identifier))
    } catch {
      return
    }
  }
}
